import { Col, Row } from "antd";
import { ServicePartnerRootImportForm } from "./components/ServicepartnerRootImportForm";

export const ServicepartnerImport = () => {
  return (
    <div>
      <Row gutter={[16, 16]}>
        <Col span={24}>
          <ServicePartnerRootImportForm />
        </Col>
      </Row>
    </div>
  );
};
